import VueLazyload from 'vue-lazyload'
import Vue from 'vue'
import config from './config'
// or with options
import {
    getSuffix,
    isPoster,
    getPrefix,
    getResizeParam,
    getVideoProcesser,
    getImgProcesser
} from './utils'
export default () =>
    Vue.use(VueLazyload, {
        preLoad: config.preLoad,
        error: config.error,
        loading: config.loading,
        attempt: 1,
        filter: {
            addProcess(listener) {
                const { el, src } = listener
                let process_src = src
                const suffix = getSuffix(src)
                if (suffix) {
                    let processer = ''
                    const is_poster = isPoster(el)
                    const prefix = getPrefix(el, src)
                    const param = getResizeParam(el)
                    if (is_poster) {
                        processer = getVideoProcesser(el, param)
                    } else {
                        processer = getImgProcesser(param, suffix)
                    }
                    process_src = prefix + src + processer
                }
                listener.src = process_src
            }
        },
        adapter: {
            loaded({ el, src }) {
                if (/video/i.test(el.tagName)) {
                    el.poster = src
                }
            }
        }
    })
